import { put, takeEvery, call } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../api';
import api from '../../api/endpoints';

function* getMerchantById({ payload: { signal, id } }) {
  try {
    const { data } = yield call(fetch, { api: api.store_domains.get, id, signal });

    yield put(actions.getMerchantByIdDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getMerchantByIdFailed,
      endpoint: api.store_domains.get.url
    });
  }
}

function* editMerchant({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.store_domains.update, id, data: values });

    onSuccess && onSuccess();
    yield put(actions.editMerchantDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.editMerchantFailed,
      handledErrors,
      endpoint: api.store_domains.update.url
    });
  }
}

export const getMerchantByIdSaga = takeEvery(types.GET_MERCHANT_BY_ID_REQUEST, getMerchantById);
export const editMerchantSaga = takeEvery(types.EDIT_MERCHANT_REQUEST, editMerchant);